import {connect} from 'react-redux';
import {intlShape, injectIntl, FormattedMessage} from 'react-intl';
import React, {Component} from 'react';
import Page from "../../app/components/Page";
import CreateAddressbook from '../forms/CreateAddressbook';
import {withRouter} from "react-router-dom";
import {
    CREATE_ADDRESSBOOK,
    CREATE_ADDRESSBOOK_FAILURE,
    CREATE_ADDRESSBOOK_SUCCESS,
} from "../addressbooks";
import {createSubmitAction} from "../../app/forms";
import Button from "../../../ui/Button";
import Helmet from 'react-helmet';

@injectIntl
export class AddressbookCreator extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            success: false,
        }
    }

    handleSuccess() {
        this.setState({success: true});
    }

    render() {
        const {success} = this.state;
        const { formatMessage } = this.props.intl;

        if (success) {
            // Forces site to reload all location information.
            const currentPath = window.location.pathname;
            window.location.href = currentPath.substring(0, currentPath.lastIndexOf("/"));
        }

        return (
            <Page.Body>
                <Helmet title={formatMessage({ id: 'frontend.pagetitle.create_addressbook' })} />
                <Page.Section depth={0}>
                    <h1>
                        <FormattedMessage id='frontend.addressbook.headline.new_company'/>
                    </h1>
                </Page.Section>
                <Page.Section>
                    <Page.Content>
                        <CreateAddressbook.Component onSubmitSuccess={() => this.handleSuccess()}
                                                     onSubmit={createSubmitAction(
                                                         CREATE_ADDRESSBOOK,
                                                         CREATE_ADDRESSBOOK_SUCCESS,
                                                         CREATE_ADDRESSBOOK_FAILURE
                                                     )}/>
                        <br/>
                        <Button link block to='./manage'>
                            <FormattedMessage id='common.helper.button.cancel'/>
                        </Button>
                    </Page.Content>
                </Page.Section>
            </Page.Body>
        );
    }
}

export default withRouter(connect(() => ({}))(AddressbookCreator));
